<template>
  <div class="jjzt">
    <sec-title Text="聚焦专题" class="text_center" />
    <div class="new mt40">
      <div class="newlist between">
        <div class="colum">
          <div v-for="(item, index) in leftdata" :key="index">
            <div
              class="tj bomf flex_start"
              @click="tojump(item)"
              v-if="index == 0"
            >
              <div class="cover">
                <img :src="item.preview_pic" />
              </div>
              <div class="newinfo">
                <div class="infotopimg">
                  <img src="../../../assets/special/infotopimg.png" alt="" />
                </div>
                <div class="bt ellipsis">{{ item.title }}</div>
                <div class="des mt10">
                  {{ item.content | toEllipsisFilter(30) }}
                </div>
                <div class="between">
                  <div class="more">more+</div>
                  <div class="time">{{ item.updated_at | strcutout}}</div>
                </div>
              </div>
            </div>
            <div class="itme bomf" v-if="index != 0" @click="tojump(item)">
              <div class="between">
                <div class="bt ellipsis">{{ item.title }}</div>
                <div class="time">{{ item.updated_at | strcutout}}</div>
              </div>
              <div class="des mt10">
                {{ item.content | toEllipsisFilter(60) }}
              </div>
            </div>
          </div>
        </div>
        <div class="colum">
          <div v-for="(item, index) in rightdata" :key="index">
            <div
              class="tj bomf flex_start"
              @click="tojump(item)"
              v-if="index == 0"
            >
              <div class="cover">
                <img :src="item.preview_pic" />
              </div>
              <div class="newinfo">
                <div class="infotopimg">
                  <img src="../../../assets/special/infotopimg.png" alt="" />
                </div>
                <div class="bt ellipsis">{{ item.title }}</div>
                <div class="des mt10">
                  {{ item.content | toEllipsisFilter(30) }}
                </div>
                <div class="between">
                  <div class="more">more+</div>
                  <div class="time">{{ item.updated_at | strcutout }}</div>
                </div>
              </div>
            </div>
            <div class="itme bomf" v-if="index != 0" @click="tojump(item)">
              <div class="between">
                <div class="bt ellipsis">{{ item.title }}</div>
                <div class="time">{{ item.updated_at | strcutout}}</div>
              </div>
              <div class="des mt10">
                {{ item.content | toEllipsisFilter(60) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <view-more class="nt10" :url="moreobj" /> -->
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import viewMore from "views/home/components/viewMore";
export default {
  components: {
    secTitle,
    viewMore,
  },
  data() {
    return {
      leftdata: [],
      rightdata: [],
      moreobj: {
        path: "/laws/speciallist",
      },
    };
  },
  beforeMount() {
    this.getlawon("new", "leftdata");
    this.getlawon("hot", "rightdata");
  },
  methods: {
    tojump(current) {
      this.$router.push({
        path: "/laws/specialdet",
        query: {
          lawonId: current.id,
        },
      });
    },
    getlawon(type, key) {
      let data = {
        limit: 3,
        order: type,
        page: 1,
      };
      this.$http.laws.getnewslist(data).then((res) => {
        this[key] = res.data.data;
      });
    },
  },
  filters:{
    strcutout(val){
      return val.substring(0,10)
    }
  }
};
</script>

<style lang="scss" scoped>
.jjzt {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .new {
    width: 100%;
    background: #ffffff;
    border: 2px solid #e6e6e6;
    padding-bottom: 40px;
    box-shadow: 0px 15px 24px 0px rgba(229, 228, 227, 0.41);
    .newlist {
      padding: 30px 36px;
      .colum {
        width: 512px;
        .bomf {
          position: relative;
          border-bottom: 1px solid #e3e3e3;
          &::after {
            content: "";
            position: absolute;
            bottom: -3px;
            left: 0;
            width: 5px;
            height: 5px;
            transform: rotate(45deg);
            background-color: #0465ea;
          }
        }
        .bt {
          width: 220px;
          font-size: 18px;
          color: #333333;
          line-height: 18px;
        }
        .des {
          font-size: 14px;
          color: #999999;
          line-height: 22px;
        }
        .time {
          padding-top: 14px;
          font-size: 12px;
          color: #666666;
        }
        .tj {
          align-items: flex-start;
          padding-bottom: 20px;
          cursor: pointer;
          .cover {
            position: relative;
            z-index: 1;
            img {
              width: 275px;
              height: 200px;
            }
          }
          .newinfo {
            padding-top: 74px;
            width: 100%;
            position: relative;
            margin-left: 16px;

            .infotopimg {
              position: absolute;
              top: 11px;
              left: -128px;
            }
            .more {
              width: 61px;
              height: 20px;
              line-height: 20px;
              text-transform: uppercase;
              text-align: center;
              background: #0465ea;
              border-radius: 4px;
              font-size: 12px;
              color: #ffffff;
              margin-top: 15px;
            }
          }
        }
        .itme {
          padding: 20px 0;
          cursor: pointer;
          .bt {
            width: 410px;
          }
          .time {
            padding-top: 0;
          }
          .mt8 {
            margin-top: 8px;
          }
          .color7b {
            color: #7b7b7b;
          }
        }
      }
    }
  }
}
</style>